module.exports = __webpack_public_path__ + "img/icon-success-purple.7421da22.svg";